import HistoryIcon from '@mui/icons-material/History';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RecentActorsOutlinedIcon from '@mui/icons-material/RecentActorsOutlined';
import GroupIcon from '@mui/icons-material/Group';
import './menu.scss';
import avatar from './avatar.svg';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddNewFirmModal from './add-new-firm.modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { resetCurrentFirm, setCurrentFirm } from '../shared/redux/firmSlicer';
import styles from '../../index.module.scss';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { MainRoute } from '../../app';
import { UserRoute } from './userContainer';
import { SubscriptionStatus } from './stripe/subscription';
import { resetCompanyList, setCurrentCompanyList } from '../shared/redux/companySlicer';
import { resetCurrentRealmId } from '../shared/redux/currentRealmSlicer';
import { resetFirmList } from '../shared/redux/firmListSlicer';
import { resetCurrentSubscription } from '../shared/redux/subscriptionSlicer';
import { resetCurrentUser } from '../shared/redux/userSlicer';
import LogoutModal from './logoutModal';
import { AdminRoute } from '../admin/adminContainer';

const version = process.env.REACT_APP_VERSION;

const MenuComponent = () => {
  const currentUser = useSelector((state: RootState) => state.currentUser.currentUser);
  const currentSubscription = useSelector((state: RootState) => state.currentSubscription.currentSubscription);
  // Redux Firm Name
  const currentFirm = useSelector((state: RootState) => state.currentFirm.currentFirm);
  const firmList = useSelector((state: RootState) => state.firmList.firmList);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tierLabel, setTierLabel] = useState<string | undefined>(undefined);
  const [userName, setUserName] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate();
  const getTierLabel = () => {
    const tier = currentSubscription?.subscriptionTier || currentUser?.subscriptionTier;
    const status = currentSubscription?.subscriptionStatus || currentUser?.subscriptionStatus;
    const isActive = status === SubscriptionStatus.Active || status === SubscriptionStatus.Trialing;
    if (!tier || !isActive) {
      return;
    }
    return tier;
  };
  const menuItems = [
    { name: 'Audit Log', icon: <HistoryIcon />, path: MainRoute.User + UserRoute.Audit },
    { name: 'Clients', icon: <RecentActorsOutlinedIcon />, path: MainRoute.User + UserRoute.Clients },
    { name: 'Users', icon: <GroupIcon />, path: MainRoute.Admin + AdminRoute.Users },
    {
      name: 'Subscription',
      icon: <DiamondOutlinedIcon />,
      path: MainRoute.User + UserRoute.Subscription,
      tierLabel
    }
  ];

  const { pathname } = useLocation();
  const isActive = (path: string) => pathname.startsWith(path);
  const logout = () => {
    setOpenLogoutModal(false);
    dispatch(resetCompanyList());
    dispatch(resetCurrentRealmId());
    dispatch(resetFirmList());
    dispatch(resetCurrentFirm());
    dispatch(resetCurrentSubscription());
    dispatch(resetCurrentUser());
    localStorage.clear();
    navigate(MainRoute.SignIn);
  };

  // Add new Firm

  const [openAddFirmModal, setOpenAddFirmModal] = useState(false);
  const [editState, setEditState] = useState(false);
  const handleSuccess = () => {
    setOpenAddFirmModal(false);
    setEditState(false);
    changeFirms();
  };
  const handleClose = () => {
    setOpenAddFirmModal(false);
    setEditState(false);
  };
  const handleAddOpen = () => {
    setAnchorEl(null);
    setEditState(false);
    setOpenAddFirmModal(true);
  };
  const handleEditOpen = () => {
    setEditState(true);
    setOpenAddFirmModal(true);
  };
  const adjustFontSizeToFit = (containerId: string) => {
    const container = document.getElementById(containerId);
    if (!container) {
      return;
    }

    let fontSize = parseInt(window.getComputedStyle(container).fontSize);
    while (container.scrollWidth > container.offsetWidth && fontSize > 0) {
      fontSize--;
      container.style.fontSize = `${fontSize}px`;
    }
  };
  useEffect(() => {
    setTierLabel(getTierLabel());
    adjustFontSizeToFit('profile-user-name');
  }, [currentSubscription, currentUser]);
  useEffect(() => {
    setUserName([currentUser?.firstName, currentUser?.lastName].filter(Boolean).join(' '));
    setEmail(currentUser?.email);
  }, [currentUser]);
  // useEffect(() => {
  //   dispatch(resetFirmList());
  //   dispatch(resetCurrentFirm());
  //   dispatch(resetCompanyList());
  //   firmRefresh(dispatch).then((firms) => {
  //     if(!firms.length){
  //       return;
  //     }
  //     dispatch(setCurrentFirmList(firms));
  //     if (currentFirm) {
  //       dispatch(setCurrentFirm(firms.find((c) => c._id === currentFirm?._id) || null));
  //       dispatch(setCurrentCompanyList(currentFirm?.companies || []));
  //     } else {
  //       dispatch(setCurrentFirm(firms[0]));
  //       dispatch(setCurrentCompanyList(firms[0]?.companies || []));
  //     }
  //   });
  // }, []);
  const changeFirms = () => {
    navigate(MainRoute.User + UserRoute.Clients);
  };
  return (
    <>
      <div className="menu-container ">
        <div className="menu-top-section">
          <div className="menu-toggle-block">
            <img src="/logo120.svg" alt="Logo" className="logo" />
            {/*<MenuOpenIcon className="menu-icon"/>*/}
          </div>
          <div className="company-name-empty-block"></div>
          <div className="company-name-section">
            {currentFirm ? (
              <span className="company-name">{currentFirm.name}</span>
            ) : (
              <Button
                onClick={handleAddOpen}
                variant="contained"
                sx={{
                  width: '140px',
                  height: '40px',
                  marginLeft: '1rem',
                  fontSize: '0.9rem',
                  gap: 0
                }}
              >
                Create Firm
              </Button>
            )}
            <div>
              <Button
                className="change-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                CHANGE <ExpandMoreIcon className="menu-icon" />
              </Button>
            </div>
            <Menu
              className="menu-change-firm"
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
            >
              {(() => {
                const grouped = (firmList || []).reduce(
                  (acc: { owners: JSX.Element[]; members: JSX.Element[] }, firm, index) => {
                    const isCurrent = Boolean(firm._id && firm._id === currentFirm?._id);
                    const isOwner = firm?.ownerId === currentUser?._id;
                    const key = (firm as any)?._id || index;

                    const currentFirmItem = isCurrent ? (
                      <MenuItem key={`current-${key}`} onClick={() => setAnchorEl(null)} className="p-0">
                        <div className="w-100 d-flex justify-content-between align-items-center px-3 py-2">
                          <Typography
                            sx={{
                              color: styles.mainGreen,
                              fontWeight: isOwner ? 700 : 500
                            }}
                          >
                            {firm.name}
                          </Typography>
                          <Button
                            hidden={!isOwner}
                            onClick={handleEditOpen}
                            variant="text"
                            sx={{ height: '27px', fontSize: '0.9rem', gap: 0 }}
                          >
                            Edit
                          </Button>
                        </div>
                      </MenuItem>
                    ) : null;

                    const regularItem = !isCurrent ? (
                      <MenuItem
                        key={key}
                        onClick={() => {
                          dispatch(setCurrentFirm(firm));
                          dispatch(setCurrentCompanyList(firm?.companies || []));
                          setAnchorEl(null);
                          dispatch(resetCurrentRealmId());
                          if (pathname.startsWith(MainRoute.User + UserRoute.Clients)) {
                            changeFirms();
                          }
                        }}
                      >
                        <Typography sx={{ fontWeight: isOwner ? 700 : 400 }}>{firm.name}</Typography>
                      </MenuItem>
                    ) : null;

                    const item = isCurrent ? currentFirmItem : regularItem;
                    if (item) {
                      if (isOwner) {
                        acc.owners.push(item);
                      } else {
                        acc.members.push(item);
                      }
                    }
                    return acc;
                  },
                  { owners: [], members: [] }
                );

                // Возвращаем массив без фрагментов
                return [...grouped.owners, ...grouped.members];
              })()}
              <hr className="blue-color my-1"></hr>
              <MenuItem
                onClick={handleAddOpen}
                className="d-flex justify-content-center"
                // sx={{ height: '2rem', color: styles.mainBlue }}
              >
                {/*<AddCircleOutlineIcon sx={{ fontSize: '1rem' }} className="me-2"/>*/}
                {/*<Typography>Create New Firm</Typography>*/}

                <Button
                  variant="text"
                  sx={{
                    color: styles.mainBlue,
                    width: '240px',
                    gap: 0
                  }}
                  startIcon={<AddCircleOutlineIcon />}
                >
                  Create New Firm
                </Button>
              </MenuItem>
            </Menu>
          </div>
          <ul className="menu-options">
            {menuItems.map((item) => (
              <li key={item.name} className="menu-item-link">
                <Link to={item.path} className={`menu-item ${isActive(item.path) ? 'active' : ''}`}>
                  {React.cloneElement(item.icon, { sx: { marginRight: '10px' } })}
                  {item.name}
                  {item.tierLabel && (
                    <span
                      className="tier-label"
                      style={{
                        marginLeft: '1rem',
                        padding: '8px',
                        borderRadius: '1rem',
                        backgroundColor: styles.mainBlue,
                        color: styles.mainWhite,
                        fontSize: '14px',
                        fontWeight: 'bold'
                      }}
                    >
                      {tierLabel}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="menu-bottom-section">
          {/*<Avatar className="avatar"/>*/}
          {/*<div className="circle-avatar"></div>*/}
          <div className="avatar-block me-3">
            <img alt="Avatar" src={avatar} />
          </div>
          <div className="profile-section">
            <div id="profile-user-name" className="user-name">
              {userName || email}
            </div>
            <div className="profile-logout-section">
              <a className="profile-button">Profile</a>
              <a className="logout-button" onClick={() => setOpenLogoutModal(true)}>
                LogOut
              </a>
            </div>
            <div>v{version}</div>
          </div>
        </div>
      </div>
      {
        <AddNewFirmModal
          open={openAddFirmModal}
          handleClose={handleClose}
          onSuccess={handleSuccess}
          edit={editState}
        ></AddNewFirmModal>
      }
      {
        <LogoutModal
          open={openLogoutModal}
          handleClose={() => setOpenLogoutModal(false)}
          handleSuccess={logout}
        ></LogoutModal>
      }
    </>
  );
};

export default MenuComponent;
